export default __webpack_public_path__ + "static/media/redwood.f58dedc5.png";